import { render, staticRenderFns } from "./AdicionarMultiplasCategoriasAoCarrinho.vue?vue&type=template&id=4ba31c0a&scoped=true"
import script from "./AdicionarMultiplasCategoriasAoCarrinho.vue?vue&type=script&lang=js"
export * from "./AdicionarMultiplasCategoriasAoCarrinho.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba31c0a",
  null
  
)

export default component.exports